/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IClientsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IClientsQuery = {
  __typename?: 'Query';
  clients: {
    __typename: 'ClientsConnection';
    edges: Array<{
      __typename: 'ClientEdge';
      cursor: string;
      node: { __typename: 'Client'; id: string; code: string; name: string; shortName?: string | null };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const ClientsDocument = gql`
  query Clients($first: Int, $after: String) {
    clients(first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          code
          name
          shortName
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useClientsQuery__
 *
 * To run a query within a React component, call `useClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useClientsQuery(baseOptions?: Apollo.QueryHookOptions<IClientsQuery, IClientsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IClientsQuery, IClientsQueryVariables>(ClientsDocument, options);
}
export function useClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IClientsQuery, IClientsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IClientsQuery, IClientsQueryVariables>(ClientsDocument, options);
}
// @ts-ignore
export function useClientsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IClientsQuery, IClientsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IClientsQuery, IClientsQueryVariables>;
export function useClientsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IClientsQuery, IClientsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IClientsQuery | undefined, IClientsQueryVariables>;
export function useClientsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IClientsQuery, IClientsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IClientsQuery, IClientsQueryVariables>(ClientsDocument, options);
}
export type ClientsQueryHookResult = ReturnType<typeof useClientsQuery>;
export type ClientsLazyQueryHookResult = ReturnType<typeof useClientsLazyQuery>;
export type ClientsSuspenseQueryHookResult = ReturnType<typeof useClientsSuspenseQuery>;
export type ClientsQueryResult = Apollo.QueryResult<IClientsQuery, IClientsQueryVariables>;
